import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import CheckoutSection1 from '../components/checkout/CheckoutSection1';

const meta = {
  title: 'Checkout - Ordio.io',
  meta: [],
  link: [],
  style: [],
  script: [
    {
      src: 'js/global-2274.js',
    },
  ],
};

export default function Checkout() {
  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet {...meta}></Helmet>
      </HelmetProvider>
      <CheckoutSection1 />
    </React.Fragment>
  );
}
